import React, { Fragment } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { desktop } from '../../../styles/media'
import Link from '../../../components/router/Link'
import deckTags from '../../../data/deckTags'
import { translationsMapping } from '../../../../config'
import { connect } from 'react-redux'
import Icon from '../../../components/general/Icon'
import formats, { TCG } from '../../../data/formats'

const DeckTags = ({ format, tags, userLanguage }) => {
	return (
		<StyledDeckTags>
			{tags.map(tagId => {
				const tag = deckTags.find(tag => tag.id === tagId)

				return (
					<Fragment key={tag.id}>
						<Tag to={`/decks/${format !== TCG ? `${formats[format].slug}/` : ''}${tag.slug}`}>
							<Icon name="tag" /><span>{tag[`name_${translationsMapping[userLanguage]}`]}</span>
						</Tag>
					</Fragment>
				)
			})}
		</StyledDeckTags>
	)
}

DeckTags.propTypes = {
	format: PropTypes.number.isRequired,
	tags: PropTypes.array.isRequired,
	userLanguage: PropTypes.string.isRequired
}

export const StyledDeckTags = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 0.35rem;
`

export const Tag = styled(Link)`
	color: ${props => props.theme.textVeryLight};
	line-height: 1.3;
	text-decoration: none;

	align-items: center;
	display: flex;
	gap: 0.15rem;

	span {
		color: ${props => props.theme.text};
		font-weight: 600;
	}

	svg {
		height: 16px;
		width: 16px;
	}

	${desktop`
		&:hover span {
			color: ${props => props.theme.primary};
		}
	`}
`

const enhance = connect(state => ({
	userLanguage: state.persist.language
}))

export default enhance(DeckTags)
